<template>
  <div class="py-5 md:px-5">
    <PageHeader class="container" title="Vehicles">
      <button class="btn btn-secondary" @click="syncGroups" v-submitting="submitting">
        Sync Groups
      </button>

      <div slot="subheader" class="mt-4 sm:mt-0">
        <NavTabs 
          :tabs="[
            { name: 'Vehicles', route: { name: 'VehicleList' } },
            { name: 'Vehicle Groups', route: { name: 'VehicleGroups' } },
          ]" 
        />
      </div>
    </PageHeader>

    <div class="container">
      <!-- Loading -->
      <Loading v-if="loading" />

      <!-- List -->
      <div class="card" v-else>
        <!-- No Results -->
        <div v-if="groups.meta.total < 1" class="py-12 text-center">
          <p class="mb-8 text-lg font-bold">
            No groups have been sync'd from WEBFLEET yet.
          </p> 
          <button class="btn btn-secondary" @click="syncGroups" v-submitting="submitting">
            Sync Groups from WEBFLEET
          </button>
        </div>

        <!-- Results -->
        <div v-else>
          <!-- Table -->
          <data-table :items="groups.data" 
            :keys="[
              { name: 'Name', slug: 'name', class: 'font-bold' }
            ]" />
          <!-- Pagination -->
          <Pagination class="rounded-b-lg" :total="groups.meta.total" :per-page="groups.meta.per_page" :current-page="groups.meta.current_page" />
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'VehicleGroups',

  metaInfo: {
    title: 'Vehicle Groups'
  },

  async created () {
    await this.getVehicleGroups()
  },

  computed: {
    ...mapGetters(['account'])
  },

  data () {
    return {
      groups: {},
      loading: true,
      submitting: false
    }
  },

  methods: {
    async getVehicleGroups () {
      try {
        this.loading = true
        const { data } = await this.$api.get(`account/${this.$route.params.account}/vehicle-groups`, {
          params: {
            page: this.$route.query.page || 1
          }
        })
        this.groups = data.groups
        this.loading = false
      } catch (error) {
        console.error(error)
        this.$toasted.error(error.response.data.message)
      }
    },
    
    async syncGroups () {
      try {
        this.submitting = true
        await this.$api.get(`account/${this.$route.params.account}/sync/vehicle-groups`)
        this.getVehicleGroups()
      } catch (error) {
        console.error(error)
        this.$toasted.error(error.response.data.message)
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>